<template>
  <div class="contentDiv">
    <div class="cover scrollable-div">
      <HeaderContainer :active-index="currentMenuIndex" @menu-select="onMenuSelect"/>


      <div class="pure">
        <article class="wrapper pub_case" id="wrapper">
          <div class="det_con">
            <div class="det_top">
              <div class="det_name">{{ title }}</div>
              <div class="det_time">{{ time }}</div>
            </div>
            <div class="det_con">{{ content }}</div>
          </div>
        </article>
      </div>


      <footer>
        <div class="foot_con pub_case pure">
          <div class="link_foo">
            <a href="" target="_blank">聯繫我們</a> |
            <a href="" target="_blank">反饋意見</a> |
            <a href="" target="_blank">私密條款</a> |
            <a href="" target="_blank">私密條款</a> |
            <a href="" target="_blank">免責聲明</a> |
            <a href="" target="_blank">網頁指南</a> |
          </div>
          <div class="copyRight at_on">
            @2011 澳門銀河娛樂有限公司版權所有 不得轉載
          </div>
        </div>
      </footer>
    </div>
  </div>

</template>

<script>
import router from "@/router";
import HeaderContainer from "@/components/HeaderContainer.vue";

export default {
  name: 'NewsNoticeInfo',
  components: {HeaderContainer},
  data() {
    return {
      currentMenuIndex:'4',
      activeTab: 1,
      title: "",
      time: "",
      content: ""
    }
  },
  created() {
    console.log("asdasdasdasdasd")
    console.log(this.$route)
    console.log(this.$route.query)
    this.title = this.$route.query.title
    this.time = this.$route.query.time
    this.content = this.$route.query.content
  },
  methods: {
    /*主键函数*/
    onMenuSelect(index, indexPath) {
      console.log('选中菜单:', index, indexPath)
    },
    router() {
      return router
    },
    routerUrl(url) {
      this.$router.replace(url);
    },

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.cover {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #021841;
  z-index: 200;
  justify-items: center;
}

.contentDiv {
  background: rgb(4, 23, 65);
  /*background-image: url("../assets/bgvideo.webp");*/
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  width: 100%;
  height: 100%;
  /*display: flex;*/
  align-items: center; /*定义父元素的元素垂直居中*/
  justify-content: center; /*定义子元素的里的元素水平居中*/
  text-align: center;
}

.header-content {
  justify-content: center;
  text-align: center;
}

.app-header {
  padding: 0;
}

.horizontal-nav {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  margin: 0;
  padding: 0;
  list-style: none;
}

.horizontal-nav li {
//margin: 0 15px; //padding: 8px 16px; color: white; border-radius: 4px;
}




.det_con {
  background-color: #132347;
  width: 1170px;
  text-align: left;
}


.det_con .det_top {
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  padding-bottom: 15px;
}
.det_con .det_top .det_name {
  font-size: 20px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.5;
  margin-left: 20px;
  padding-top: 20px;
}

.det_con .det_con {
  color: #fff;
  font-size: 14px;
  line-height: 1.8;
  padding: 10px 0 15px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
}

.det_con .det_top .det_time {
  line-height: 1;
  color: rgba(255, 255, 255, 0.6);
  font-size: 12px;
  margin-top: 10px;
}

.det_con .det_con p {
  margin-bottom: 0;
}




@media (max-width: 768px) {
  .kj_tba img {
    width: 18px;
    height: 18px;
    max-width: 100%;
    height: auto;
  }

  .kj_tba td:nth-child(4) img {
    margin: 0 2px;
  }

  .link_foo{
    font-size: 4px;
  }

  .copyRight{
    font-size: 4px;
  }
  .det_con {
    background-color: #132347;
    width: 100%;
  }
}



.scrollable-div {

  overflow-y: auto; /* 垂直滚动 */
  overflow-x: auto; /* 隐藏水平滚动 */
  border: 1px solid #ddd;
  border-radius: 4px;
}

footer .foot_con {
  padding: 15px 0;
  color: #4e6692;
  font-size: 12px;
}

.pub_case {
  margin-left: auto;
  margin-right: auto;
}

footer .link_foo {
  float: right;
}

footer .copyRight {
  float: left;
}

footer .foot_con a {
  color: #4e6692;
}
</style>

